import { useParams } from 'react-router-dom';

import useIntegration from 'api/useIntegration';
import { capitalizeFirstLetter } from 'utils/formattingUtil';

import { ESettingsState } from 'components/Settings/Settings.types';
import SharedSettingsView from 'components/Settings/SharedSettingsView';

const SettingsView = () => {
  const { publisherId } = useParams();
  const { getIntegration } = useIntegration(publisherId);

  const tabs = [
    {
      label: capitalizeFirstLetter(ESettingsState.PORTAL),
      value: ESettingsState.PORTAL
    },
    {
      label: capitalizeFirstLetter(ESettingsState.USERS),
      value: ESettingsState.USERS
    },
    {
      label: capitalizeFirstLetter(ESettingsState.INTEGRATION),
      value: ESettingsState.INTEGRATION
    },
    { label: 'Authentication', value: ESettingsState.PLAYER_AUTH },
    { label: 'Events Center', value: ESettingsState.EVENTS }
  ];

  return (
    <SharedSettingsView
      tabs={tabs}
      defaultTab={ESettingsState.PORTAL}
      headline="Portal settings"
      basePath="portal"
      onTabChange={() => getIntegration.refetch()}
    />
  );
};

export default SettingsView;
